import { createContext, useContext, type Accessor } from "solid-js"
import type { ReportChatScope } from "@/datox/api"

export type SessionEmbed = {
  agent: string
  disabled: Accessor<boolean>
  visible: Accessor<boolean>
  scope: Accessor<ReportChatScope | undefined>
  followupMode?: Accessor<"steer" | "queue" | undefined>
  request: Accessor<{ id: number; text: string } | undefined>
  onResults: () => void
  onMessages: (sessionID: string, hasMessages: boolean) => void
  onNew: () => void
}

export const SessionEmbedContext = createContext<SessionEmbed>()
export const useSessionEmbed = () => useContext(SessionEmbedContext)
